import { render } from "./examcategories.vue?vue&type=template&id=f1f0c7f6&scoped=true"
import script from "./examcategories.vue?vue&type=script&lang=js"
export * from "./examcategories.vue?vue&type=script&lang=js"

import "@/assets/css/ts-table.css?vue&type=style&index=0&id=f1f0c7f6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f0c7f6"]])

export default __exports__